import { Stack, BaseCard, Title, Text, Input } from '@tiendanube/components';
import useTranslationCatalog from 'domains/Catalog/useTranslationCatalog';

function Skeleton(): JSX.Element {
  const t = useTranslationCatalog();
  const title = t('categories.detail.googleShopping.title');
  const subtitle = t('categories.detail.googleShopping.subtitle');

  return (
    <BaseCard>
      <BaseCard.Header>
        <Stack column spacing="tight" align="stretch">
          <Title type="h3">{title}</Title>
          <Text>{subtitle}</Text>
        </Stack>
      </BaseCard.Header>
      <BaseCard.Body>
        <Stack column spacing="base" align="stretch">
          <Stack column spacing="tight" align="stretch">
            <Input.Skeleton />
            <Text.Skeleton width="large" />
          </Stack>
        </Stack>
      </BaseCard.Body>
    </BaseCard>
  );
}

export default Skeleton;
